import React from 'react'

function Second() {
  return (
   <>
        <section className="faq-two">
            <div className="container">
                <div className="row gutter-y-60">
                <div className="col-md-12 col-lg-6 d-flex">
                    <div className="my-auto">
                    <div className="faq-two__content">
                        <div className="sec-title text-start">
                        <p className="sec-title__tagline">Service &amp; Pricing</p>
                       
                        <h3 className="sec-title__title">
                            Learn About Services <br />
                            and Pricing Plan{" "}
                        </h3>
                        
                        </div>
                        
                        <div
                        className="accordion faq-two__accordion"
                        id="faq-two__accordion-2" >
                        <div className="accordion-item faq-two__accordion__item accordion--active">
                            <h2
                            className="accordion-header faq-two__accordion__header"
                            id="faq-two__accordion-2__heading-1" >
                            <button
                                className="accordion-button faq-two__accordion__button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq-two__accordion-2__collapse-1"
                                aria-expanded="true"
                                aria-controls="faq-two__accordion-2__collapse-1" >
                                How does Finkeda simplify premium collection and payment?
                                <span className="faq-two__accordion__icon" />
                        
                            </button>
                            </h2>
                            <div id="faq-two__accordion-2__collapse-1"
                            className="accordion-collapse collapse show faq-two__accordion__collapse"
                            aria-labelledby="faq-two__accordion-2__heading-1"
                            data-bs-parent="#faq-two__accordion-2" >
                            <div className="accordion-body faq-two__accordion__body">
                            Finkeda allows authorized agents and insurers to manage and process payments in real time. The platform ensures accuracy, transparency, and speed — removing the friction often seen in traditional insurance payment systems.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item faq-two__accordion__item">
                            <h2 className="accordion-header faq-two__accordion__header"
                            id="faq-two__accordion-2__heading-2" >
                            <button
                                className="accordion-button faq-two__accordion__button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq-two__accordion-2__collapse-2"
                                aria-expanded="false"
                                aria-controls="faq-two__accordion-2__collapse-2" >
                                How quickly are payments processed on Finkeda?
                                <span className="faq-two__accordion__icon" />
                            </button>
                            </h2>
                            <div id="faq-two__accordion-2__collapse-2"
                            className="accordion-collapse faq-two__accordion__collapse collapse"
                            aria-labelledby="faq-two__accordion-2__heading-2"
                            data-bs-parent="#faq-two__accordion-2" >
                            <div className="accordion-body faq-two__accordion__body">
                            Payments are typically processed instantly, with real-time confirmation and automated updates for both insurers and customers.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item faq-two__accordion__item">
                            <h2 className="accordion-header faq-two__accordion__header" id="faq-two__accordion-2__heading-3" >
                            <button
                                className="accordion-button faq-two__accordion__button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq-two__accordion-2__collapse-3"
                                aria-expanded="false"
                                aria-controls="faq-two__accordion-2__collapse-3" >
                               Will I receive a confirmation or receipt after payment?
                                <span className="faq-two__accordion__icon" />
                            </button>
                            </h2>
                            <div id="faq-two__accordion-2__collapse-3"
                            className="accordion-collapse faq-two__accordion__collapse collapse"
                            aria-labelledby="faq-two__accordion-2__heading-3"
                            data-bs-parent="#faq-two__accordion-2" >
                            <div className="accordion-body faq-two__accordion__body">
                            Yes. Every successful transaction on Finkeda generates a transparent digital receipt, ensuring complete payment traceability and record-keeping.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item faq-two__accordion__item">
                            <h2 className="accordion-header faq-two__accordion__header" id="faq-two__accordion-2__heading-4" >
                            <button className="accordion-button faq-two__accordion__button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-two__accordion-2__collapse-4" aria-expanded="false" aria-controls="faq-two__accordion-2__collapse-4" >
                            What advantages does Finkeda offer to insurance providers?
                                <span className="faq-two__accordion__icon" />
                            </button>
                            </h2>
                            <div id="faq-two__accordion-2__collapse-4" className="accordion-collapse faq-two__accordion__collapse collapse"
                            aria-labelledby="faq-two__accordion-2__heading-4"
                            data-bs-parent="#faq-two__accordion-2" >
                            <div className="accordion-body faq-two__accordion__body">
                            Finkeda helps insurers accelerate payment collections, automate reconciliations, and reduce administrative overhead. This allows providers to focus more on customer experience and business growth.
                            </div>
                            </div>
                        </div>
                        
                        </div>
                    </div>
                    
                    </div>
                   
                </div>
               
                <div className="col-md-12 col-lg-6">
                    <img src="assets/images/resources/faq-1-1.jpg" className="img-fluid"  />
                </div>
               
                </div>
                
            </div>
        </section>

        <section className="faq-two">
            <div className="container">
                <div className="row gutter-y-60">
                <div className="col-md-12 col-lg-6">
                    <img src="assets/images/resources/faq-1-2.jpg" className="img-fluid"  />
                </div>
                
                <div className="col-md-12 col-lg-6 d-flex">
                    <div className="my-auto">
                    <div className="faq-two__content faq-two__content--ml">
                        <div className="sec-title text-start">
                        <p className="sec-title__tagline">Accessibility &amp; Support</p>
                        
                        <h3 className="sec-title__title">
                        Learn About Accessibility & Support{" "}
                        </h3>
                       
                        </div>
                        
                        <div className="accordion faq-two__accordion faq-two__accordion--ml" id="faq-two__accordion-3" >
                        <div className="accordion-item faq-two__accordion__item accordion--active">
                            <h2 className="accordion-header faq-two__accordion__header" id="faq-two__accordion-3__heading-1" >
                            <button className="accordion-button faq-two__accordion__button"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq-two__accordion-3__collapse-1"
                                aria-expanded="true"
                                aria-controls="faq-two__accordion-3__collapse-1" >
                                Can I access Finkeda from anywhere?
                                <span className="faq-two__accordion__icon" />
                                
                            </button>
                            </h2>
                            <div id="faq-two__accordion-3__collapse-1" className="accordion-collapse collapse show faq-two__accordion__collapse" aria-labelledby="faq-two__accordion-3__heading-1"
                            data-bs-parent="#faq-two__accordion-3" >
                            <div className="accordion-body faq-two__accordion__body">
                            Absolutely. Finkeda is a cloud-based platform accessible from any device with an internet connection — ideal for both urban and remote users.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item faq-two__accordion__item">
                            <h2 className="accordion-header faq-two__accordion__header" id="faq-two__accordion-3__heading-2" >
                            <button
                                className="accordion-button faq-two__accordion__button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq-two__accordion-3__collapse-2"
                                aria-expanded="false"
                                aria-controls="faq-two__accordion-3__collapse-2" >
                                Is there a mobile version or app for Finkeda?
                                <span className="faq-two__accordion__icon" />
                            </button>
                            </h2>
                            <div id="faq-two__accordion-3__collapse-2" className="accordion-collapse faq-two__accordion__collapse collapse"
                            aria-labelledby="faq-two__accordion-3__heading-2"
                            data-bs-parent="#faq-two__accordion-3" >
                            <div className="accordion-body faq-two__accordion__body">
                            Finkeda currently runs seamlessly on all web browsers. A dedicated mobile app is in development to make access even easier in the future.
                            </div>
                            </div>
                        </div>
                        <div className="accordion-item faq-two__accordion__item">
                            <h2 className="accordion-header faq-two__accordion__header"
                            id="faq-two__accordion-3__heading-3" >
                            <button className="accordion-button faq-two__accordion__button collapsed" type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq-two__accordion-3__collapse-3"
                                aria-expanded="false"
                                aria-controls="faq-two__accordion-3__collapse-3" >
                                What should I do if I face issues using the platform?
                                <span className="faq-two__accordion__icon" />
                            </button>
                            </h2>
                            <div id="faq-two__accordion-3__collapse-3"
                            className="accordion-collapse faq-two__accordion__collapse collapse"
                            aria-labelledby="faq-two__accordion-3__heading-3"
                            data-bs-parent="#faq-two__accordion-3" >
                            <div className="accordion-body faq-two__accordion__body">
                            Our customer support team is always ready to help. You can reach out via email at service1@finrelinsure.com or phone: 08069627000 for guidance and troubleshooting assistance.
                            </div>
                            </div>
                        </div>
                        
                       
                        </div>
                    </div>
                   
                    </div>
                    
                </div>
                
                </div>
                
            </div>
        </section>

   </>
  )
}

export default Second